'use client'
import heyaExploreHotelsData from '@/src/constants/hotels/heyaExploreHotels.json'
import exploreHotelsData from '@/src/constants/hotels/homeExploreHotels.json'
import { useIsHeya } from '@/src/hooks/useThemeKey'
import { useLocale, useTranslations } from 'next-intl'
import { useMemo } from 'react'
import ExploreMoreHotels, { ExploreCity } from './exploreMoreHotels'

// Logic layer: resolves the localized city + hotel names/links for the Explore-more-Hotels
// grid (ported from me-flyin's xplrHsect static list).
const ExploreMoreHotelsWrapper: React.FC = () => {
    const t = useTranslations('homePage.headings')
    const locale = useLocale()
    const isArabic = locale === 'ar'
    // Heya lists its own Saudi hotels; every other host keeps the default list.
    const isHeya = useIsHeya()

    const cities = useMemo<ExploreCity[]>(
        () =>
            (isHeya ? heyaExploreHotelsData : exploreHotelsData).cities.map(city => ({
                id: city.id,
                iconKey: city.iconKey,
                name: isArabic ? city.name_ar || city.name_en : city.name_en,
                hotels: city.hotels.map(hotel => ({
                    name: isArabic ? hotel.name_ar || hotel.name_en : hotel.name_en,
                    href: isArabic ? hotel.href_ar || hotel.href_en : hotel.href_en
                }))
            })),
        [isArabic, isHeya]
    )

    if (cities.length === 0) return null

    // Heya lists six cities, laid out as two rows of three.
    return <ExploreMoreHotels title={t('exploreMoreHotels')} cities={cities} desktopColumns={isHeya ? 3 : 4} />
}

export { ExploreMoreHotelsWrapper }
export default ExploreMoreHotelsWrapper
